<template>
  <div>
    <loginbox></loginbox>
    <div class="tit_d">
      <span>> 首页 - <span class="blue">出售账号</span></span>
    </div>
    <detailbox :title="'活动详情'" :info="info.sell_info"></detailbox>
    <infolist :title="'出售账号'" :type="1" :qq="info.qq_sell" :qqShow="info.display_qq_sell" :wechat="info.service_sell" :wechatShow="info.display_weixin_sell"></infolist>
    <detailbox :title="'活动细则'" :info="info.sell_rule"></detailbox>
    <div class="bar"></div>
  </div>
</template>

<script>
  import loginbox from '@/components/common/loginbox/loginbox'
  import detailbox from '@/components/common/detailbox/detailbox'
  import infolist from '@/components/common/infolist/infolist'
  import { configResource } from '@/resource/resource'
  import {mapState, mapMutations} from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'sellpage',
    data () {
      return {
        info: ''
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
      this.scroll()
      if (!this.config_info.seInfo) {
        this.getConfig()
      } else {
        this.info = this.config_info.seInfo
      }
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      },
      getConfig () {
        configResource.config({ config: 'sell_info,sell_rule,qq_sell,display_qq_sell,display_weixin_sell,service_sell' }).then(response => {
          response = response.body
            if (response.errcode === ERR_OK) {
              this.config_info.seInfo = response.data
              this.info = response.data
            }
        })
      },
        // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO'
      ])
    },
    components: {
      loginbox,
      detailbox,
      infolist
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
  .tit_d
    height 0.8rem
    line-height 0.8rem
    padding-left 0.28rem
    font-size 0.28rem
    color #222
    background-color #fff
    .blue
      color $blue
</style>



// WEBPACK FOOTER //
// src/components/sellpage/sellpage.vue